<template>
  <div class="kk-grids">
    <nav-header :title="'Grids'"></nav-header>

    <!-- Body -->
    <div class="kk-grids__tree" @click="click" @contextmenu="rightClick" @dblclick="dblClick">
      <tree v-if="Object.keys(hashTable).length > 0" :data="allTreeGrids" :depth="0" />
    </div>
    <!-- footer -->
    <nav-footer :items="footerItems" store="grids"></nav-footer>
  </div>
</template>
<script>
import Tree from "./Tree.vue";
import NavHeader from "../RedZoneHeader.vue";
import { Direction, HotkeyScopes, TreeDefaultNodeIds } from "../../../../utils/constants";
import hotkeys from "hotkeys-js";
import NavFooter from "../RedZoneFooter.vue";
import DesignerMixin from "../../../process-design/DesignerMixin";
import { icons, ProcessItemTypes } from "../../../../utils/icons";
import { navigateTo } from "../../../../router";

const getItemId = (e) => {
  const node = e.target.closest(".kk-tree__title");
  if (!node) return [];
  const itemId = node.getAttribute("item-id");
  return [node.dataset.id, itemId];
};

export default {
  components: {
    Tree,
    NavHeader,
    NavFooter,
  },
  mixins: [DesignerMixin],
  data() {
    return {
      keyPressed: null,
      ProcessItemTypes: ProcessItemTypes,
      icons: icons,
    };
  },
  computed: {
    hashTable() {
      return this.$store.state.grids.hashTable;
    },
    footerItems() {
      return [
        {
          id: 1,
          title: this.$t("sidebar.newGrid"),
          icon: `${this.icons[this.ProcessItemTypes.Grid]}`,
          func: this.addGrid,
          testId: "footer-new-grid-option",
        },
      ];
    },
    allTreeGrids() {
      const tree = this.$store.state.grids.tree?.activeSubTree;
      if (!tree) return [];

      // Do not show ROOT element
      if (tree.id === "ROOT") {
        return tree.children;
      }
      return [tree];
    },
    activeGrid() {
      return this.$store.state.grids.activeGrid;
    },
  },
  mounted() {
    hotkeys("up", HotkeyScopes.Sidebar.Grids, (event, handler) => {
      event.preventDefault();
      this.$store.dispatch("grids/moveActiveItem", Direction.Up);
    });
    hotkeys("down", HotkeyScopes.Sidebar.Grids, (event, handler) => {
      event.preventDefault();
      this.$store.dispatch("grids/moveActiveItem", Direction.Down);
    });
    hotkeys(
      "right,left,enter,f2,Space,-,del,ctrl+up,cmd+up,ctrl+down,cmd+down,ctrl+right,cmd+right,cmd+left,ctrl+left,f10,93",
      HotkeyScopes.Sidebar.Grids,
      (event, handler) => {
        if (!this.activeGrid.id) return;
        event.preventDefault();

        const grid = this.$store.getters["grids/getGridById"](this.activeGrid.id);
        switch (handler.key) {
          case "right":
            return this.$store.dispatch("grids/toggleExpanded", {
              id: this.activeGrid.id,
              itemId: this.activeGrid.itemId,
              expanded: true,
            });
          case "left":
            return this.$store.dispatch("grids/toggleExpanded", {
              id: this.activeGrid.id,
              itemId: this.activeGrid.itemId,
              expanded: false,
            });
          case "enter": {
            return this.$store.dispatch("grids/open", this.activeGrid.id);
          }
          case "Space":
            return this.$store.dispatch("grids/toggleExpanded", {
              id: this.activeGrid.id,
              itemId: this.activeGrid.itemId,
            });
          case "del":
            if (grid.level === 1) return;
            if (this.$route.params?.id == this.activeGrid.itemId) {
              navigateTo("/designs");
              this.$store.dispatch("cells/resetFormulaRange");
              this.$store.dispatch("cells/resetState");
              this.$store.dispatch("pdesign/resetOpenedItem");
            }
            return this.$store.dispatch(`grids/remove`, { ids: [this.activeGrid.id] });
          case "cmd+up":
          case "ctrl+up":
            return this.$store.dispatch("grids/moveNode", { id: this.activeGrid.id, direction: Direction.Up });
          case "cmd+down":
          case "ctrl+down":
            return this.$store.dispatch("grids/moveNode", { id: this.activeGrid.id, direction: Direction.Down });
          case "cmd+left":
          case "ctrl+left":
            return this.$store.dispatch("grids/moveNodeOneLevel", { id: this.activeGrid.id, direction: Direction.Up });
          case "cmd+right":
          case "ctrl+right":
            return this.$store.dispatch("grids/moveNodeOneLevel", {
              id: this.activeGrid.id,
              direction: Direction.Down,
            });
          case "f10":
          case "93": {
            const element = document
              .querySelector(`.kk-grids__tree [data-id="${this.activeGrid.id}"]`)
              ?.getBoundingClientRect();
            const x = element.x + element.width / 2;
            const y = element.top + element.height / 2;
            this.$store.dispatch("grids/setActiveItem", {
              id: this.activeGrid.id,
              itemId: this.activeGrid.itemId,
            });
            return this.$store.dispatch("setActiveContextMenu", { id: this.activeGrid.id, x, y });
          }
          case "f2":
            this.editGrid();
        }
      }
    );
    hotkeys("n,g", HotkeyScopes.Sidebar.Grids, (event, handler) => {
      if (!this.activeGrid.id) return;

      const grid = this.$store.getters["grids/getGridById"](this.activeGrid.id);
      if (grid.parents[1] === TreeDefaultNodeIds.Trash) return;

      switch (handler.key) {
        case "n":
          if (this.keyPressed === null) return (this.keyPressed = handler.key);
          break;
        case "g":
          if (!this.keyPressed) return;
          this.addGrid();
          return (this.keyPressed = null);
      }
    });
  },
  beforeUnmount() {
    this.keyPressed = null;
    hotkeys.unbind(
      "n,g,up,down,right,left,enter,f2,Space,-,del,ctrl+up,cmd+up,ctrl+down,cmd+down,ctrl+right,cmd+right,cmd+left,ctrl+left,f10,93",
      HotkeyScopes.Sidebar.Grids
    );
  },
  methods: {
    click(e) {
      const [id, itemId] = getItemId(e);
      if (!id || !itemId) return;

      this.$store.dispatch("grids/toggleExpanded", { id, itemId });
      this.$store.dispatch("setScope", HotkeyScopes.Sidebar.Grids);
    },
    rightClick(e) {
      const [id, itemId] = getItemId(e);
      if (!id || !itemId) return;

      e.preventDefault();
      if (e.button == -1) return; // ignore shift+f10 key press.
      this.$store.dispatch("grids/setActiveItem", { id, itemId });
      return this.$store.dispatch("setActiveContextMenu", { id, x: e.x, y: e.y });
    },
    dblClick(e) {
      const [id, itemId] = getItemId(e);
      if (!id || !itemId) return;

      this.$store.dispatch("grids/setActiveItem", { id, itemId });
      this.$store.dispatch("grids/open", id);
    },
    addGrid() {
      this.$store.dispatch("grids/addGrid", this.activeGrid.id);
    },
    editGrid() {
      const grid = this.$store.getters["grids/getGridById"](this.activeGrid.id);
      if (grid.parents[1] === TreeDefaultNodeIds.Trash) return;
      return this.$store.dispatch("grids/setActiveItem", {
        id: this.activeGrid.id,
        editMode: true,
        itemId: this.activeGrid.itemId,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.kk-grids {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  &__tree {
    padding-top: 0.4rem;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
